(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velo-lease-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
// Annuïteit: vast maandbedrag over n maanden bij een jaarrente in %
const annuity = (amount, annualPct, n) => {
const r = annualPct / 100 / 12;
if (!r) return amount / n;
return (amount * r) / (1 - Math.pow(1 + r, -n));
};
function init(root) {
if (!root || root.dataset.leaseReady) return;
const qtyInput = root.querySelector('[data-qty-input]');
if (!qtyInput) return;
root.dataset.leaseReady = 'true';
const cfg = { downPct: 25, rate: 8, maxQty: 12, bulkFrom: 6, discountPct: 0, maxTerm: 24, install: 0, wa: '', intro: '' };
try { Object.assign(cfg, JSON.parse(root.querySelector('[data-lease-config]').textContent)); } catch (e) {}
const t = Object.assign({ months: 'months', perMonth: ' /mo', term: 'Term', down: 'Down payment', monthly: 'Indicative monthly payment', discount: 'Volume discount', subject: 'Lease request' }, cfg.i18n || {});
const loc = cfg.locale || 'en-IE';
const fmt = new Intl.NumberFormat(loc, { style: 'currency', currency: 'EUR' });
const fmt0 = new Intl.NumberFormat(loc, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const money = (v) => fmt.format(Math.round(v * 100) / 100);
// Volumekorting: vanaf cfg.bulkFrom stuks gaat cfg.discountPct % van het producttotaal af
const calc = (price, qty, n) => {
const subtotal = price * qty;
const discount = qty >= cfg.bulkFrom && cfg.discountPct > 0 ? Math.round(subtotal * cfg.discountPct) / 100 : 0;
const total = subtotal - discount;
const down = (total * cfg.downPct) / 100;
const financed = total - down;
const monthly = annuity(financed, cfg.rate, n);
return { subtotal, discount, total, down, financed, monthly, totalFin: monthly * n, interest: monthly * n - financed };
};
const set = (key, val) => root.querySelectorAll(`[data-out="${key}"]`).forEach((el) => { el.textContent = val; });
const picked = (group) => root.querySelector(`input[data-group="${group}"]:checked`);
const models = [...root.querySelectorAll('input[data-group="model"]')];
const minus = root.querySelector('[data-qty="-1"]');
const plus = root.querySelector('[data-qty="1"]');
const bulk = root.querySelector('[data-bulk]');
// Model voorselecteren via ?model=<handle> (vanaf de lease-knop op de productpagina)
let fromProduct = false;
try {
const wanted = new URLSearchParams(window.location.search).get('model');
const match = wanted && models.find((m) => m.value === wanted);
if (match) { match.checked = true; fromProduct = true; }
} catch (e) {}
// "Al vanaf" = goedkoopste model, 1 stuk, langste looptijd
const cheapest = Math.min(...models.map((m) => Number(m.dataset.price) / 100));
if (isFinite(cheapest)) set('from', fmt0.format(Math.ceil(calc(cheapest, 1, cfg.maxTerm).monthly)));
const clampQty = () => {
let q = parseInt(qtyInput.value, 10);
if (!q || q < 1) q = 1;
if (q > cfg.maxQty) q = cfg.maxQty;
qtyInput.value = q;
return q;
};
function update() {
const model = picked('model');
if (!model) return;
const termEl = picked('term');
const n = termEl ? Number(termEl.value) : 12;
const qty = clampQty();
const unit = Number(model.dataset.price) / 100;
const r = calc(unit, qty, n);
set('monthly', money(r.monthly));
set('qtyLabel', `${qty}× ${model.dataset.title}`);
set('term', `${n} ${t.months}`);
set('unit', money(unit));
set('subtotal', money(r.subtotal));
set('discountNeg', '− ' + money(r.discount));
set('total', money(r.total));
set('down', money(r.down));
set('downNeg', '− ' + money(r.down));
set('financed', money(r.financed));
set('interest', money(r.interest));
set('interestPos', '+ ' + money(r.interest));
set('totalFin', money(r.totalFin));
set('grand', money(r.down + r.totalFin));
set('install', money(cfg.install * qty));
root.querySelectorAll('[data-discount-row]').forEach((el) => { el.hidden = r.discount <= 0; });
const sum = r.down + r.totalFin;
const bar = (k, v) => { const el = root.querySelector(`[data-bar="${k}"]`); if (el) el.style.flexGrow = Math.max(v / sum, 0.02); };
bar('down', r.down); bar('fin', r.financed); bar('int', r.interest);
// Maandbedrag per model op de kaart, bij gekozen looptijd en 1 stuk
models.forEach((m) => {
const out = m.closest('.vl-model').querySelector('[data-card-monthly]');
if (out) out.textContent = fmt0.format(Math.ceil(calc(Number(m.dataset.price) / 100, 1, n).monthly)) + t.perMonth;
});
if (minus) minus.disabled = qty <= 1;
if (plus) plus.disabled = qty >= cfg.maxQty;
const isBulk = qty >= cfg.bulkFrom;
if (bulk) bulk.classList.toggle('is-active', isBulk);
root.querySelectorAll('[data-volume]').forEach((el) => { el.hidden = !isBulk; });
const lines = [
cfg.intro,
`${qty}x ${model.dataset.title}`,
r.discount > 0 ? `${t.discount} (${cfg.discountPct}%): − ${money(r.discount)}` : '',
`${t.term}: ${n} ${t.months}`,
`${t.down}: ${money(r.down)}`,
`${t.monthly}: ${money(r.monthly)}`
].filter(Boolean);
const text = encodeURIComponent(lines.join('\n'));
if (cfg.wa) root.querySelectorAll('[data-cta]').forEach((a) => { a.href = `https://wa.me/${cfg.wa}?text=${text}`; });
root.querySelectorAll('[data-mail]').forEach((a) => {
a.href = a.href.split('?')[0] + `?subject=${encodeURIComponent(t.subject)}&body=${text}`;
});
}
root.addEventListener('change', update);
root.querySelectorAll('[data-qty]').forEach((btn) => {
btn.addEventListener('click', () => {
qtyInput.value = clampQty() + Number(btn.dataset.qty);
update();
});
});
update();
if (fromProduct) {
const calcEl = root.querySelector('.vl-calc');
if (calcEl) setTimeout(() => calcEl.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
}
}
const boot = () => document.querySelectorAll('[data-velo-lease]').forEach(init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-velo-lease]')));
})();

  } catch(e) { console.error(e); }
})();
})();
